import { Box, Divider, Grid } from '@mui/material'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import React from 'react'

export const RelogioPonto: React.FC = () => {
    return (
        <Box component="section" id="relogio-ponto">
            <Divider sx={{ marginBottom: 2, marginTop: 3 }} textAlign="center">
                Relógio de ponto
            </Divider>
            <Grid container columns={24} spacing={1} columnSpacing={2}>
                <Grid item xs={12}>
                    <FormField name="repCodigo" label="Cód/Matrícula" />
                </Grid>
                <Grid item xs={12}>
                    <FormField name="repProximidade" label="Proximidade/RFID" />
                </Grid>
                <Grid item xs={12}>
                    <FormField name="repCodBarras" label="Código de barras" />
                </Grid>
                <Grid item xs={12}>
                    <FormField name="repSenha" label="Senha" />
                </Grid>
                <Grid item xs={12}>
                    <FormFieldCheckbox
                        name="repSupervisor"
                        label="Supervisor"
                    />
                </Grid>
            </Grid>
        </Box>
    )
}
